/* eslint-disable @next/next/no-sync-scripts */
'use client';
import React from 'react';
import { Section, Container } from '@layout';
import { Card, Loader, Heading } from '@ui';
import MarkupSnippet, { markupCopyLabels } from '../markup-snippet/MarkupSnippet';

interface LoadersProps {
  sectionID?: string;
  classes?: string;
  containerId?: string;
  containerClasses?: string;
  isSpanish?: boolean;
}

const Loaders: React.FC<LoadersProps> = ({
  isSpanish = false,
  sectionID = '',
  classes = '',
  containerId,
  containerClasses,
}) => {
  const t = (en: string, es: string) => (isSpanish ? es : en);

  return (
    <Section sectionID={sectionID} className={classes}>
      <Container containerId={containerId} containerClasses={containerClasses}>
        <Heading as='h3'>{t('Loaders', 'Cargadores')}</Heading>
        <p className='sub full'>
          {isSpanish ? (
            <>
              El componente <strong>Loader</strong> es un pequeño spinner personalizable que se usa
              para mostrar estados de carga. Acepta las propiedades <code>width</code>,{' '}
              <code>height</code> y <code>border</code> (cadenas o números) y establece variables
              CSS coincidentes (<code>--loader-width</code>, <code>--loader-height</code>,{' '}
              <code>--loader-border</code>) para que el spinner del pseudoelemento se pueda
              estilizar de forma consistente. Coloca el loader dentro de un contenedor centrado o
              usa un padre con posición (por ejemplo <code>position: relative</code>) cuando
              muestres un overlay.
            </>
          ) : (
            <>
              The <strong>Loader</strong> component is a small, customizable spinner used for
              showing loading states. It accepts <code>width</code>, <code>height</code>
              and <code>border</code> props (strings or numbers) and sets matching CSS variables (
              <code>--loader-width</code>, <code>--loader-height</code>,<code>--loader-border</code>
              ) so the pseudo-element spinner can be styled consistently. Place the loader inside a
              centered container or use a positioned parent (e.g. <code>position: relative</code>)
              when showing an overlay.
            </>
          )}
        </p>
        <div className='grid-3'>
          <Card>
            <div className='center-flex'>
              <Loader
                width='3.2rem'
                height='3.2rem'
                border='4px solid color-mix(in oklab, var(--ink-300) 50%, var(--brand-700) 50%);'
              />
            </div>
          </Card>
          <Card>
            <div className='center-flex'>
              <Loader
                width='3.2rem'
                height='3.2rem'
                border='4px dotted color-mix(in oklab, var(--ink-300) 50%, var(--brand-700) 50%);'
              />
            </div>
          </Card>
          <Card>
            <div className='center-flex'>
              <Loader
                width='3.2rem'
                height='3.2rem'
                border='4px dashed color-mix(in oklab, var(--ink-300) 50%, var(--brand-700) 50%);'
              />
            </div>
          </Card>
        </div>
        <MarkupSnippet
          {...markupCopyLabels(isSpanish)}
          code={`<div class="loader" role="status" aria-label="Loading" style="--loader-width: 3.2rem; --loader-height: 3.2rem; --loader-border: 4px solid var(--brand-700);"></div>`}
        />
      </Container>
    </Section>
  );
};

export default Loaders;
